'use client';

import * as DS from '@aurorasolar/ds';

import { SOLUTION_BLURBS, SOLUTION_DETAILS } from '../content';
import { HeatingFuel, SimulationToggles } from '../engine';

import { SolutionToggleRow } from './SolutionToggleRow';

type Props = {
  heatingFuel: HeatingFuel;
  onChange: (patch: Partial<SimulationToggles>) => void;
  toggles: SimulationToggles;
};

export const SolutionToggles = ({ heatingFuel, onChange, toggles }: Props) => {
  const hasHeatPump = heatingFuel === 'HEAT_PUMP';
  const hasNoHeating = heatingFuel === 'NONE';

  return (
    <DS.Grid columnGap={3} gridTemplateColumns={{ _: '1fr', md: 'repeat(3, 1fr)' }} rowGap={3} w="100%">
      <SolutionToggleRow
        blurb={SOLUTION_BLURBS.solar}
        detail={SOLUTION_DETAILS.solar}
        label="Solar panels"
        onToggle={(toggled) => onChange({ solar: toggled })}
        toggled={toggles.solar}
      />
      <SolutionToggleRow
        blurb={SOLUTION_BLURBS.battery}
        detail={SOLUTION_DETAILS.battery}
        label="Home battery"
        onToggle={(toggled) => onChange({ battery: toggled })}
        toggled={toggles.battery}
      />
      <SolutionToggleRow
        blurb={hasHeatPump ? 'You already heat with a heat pump.' : SOLUTION_BLURBS.heatPump}
        detail={hasHeatPump || hasNoHeating ? undefined : SOLUTION_DETAILS.heatPump}
        disabled={hasHeatPump || hasNoHeating}
        label="Heat pump"
        onToggle={(toggled) => onChange({ heatPump: toggled })}
        toggled={toggles.heatPump && !hasHeatPump && !hasNoHeating}
      />
      <SolutionToggleRow
        blurb={SOLUTION_BLURBS.insulation}
        detail={SOLUTION_DETAILS.insulation}
        label="Insulation and air sealing"
        onToggle={(toggled) => onChange({ insulation: toggled })}
        toggled={toggles.insulation}
      />
      <SolutionToggleRow
        blurb={SOLUTION_BLURBS.smartHome}
        detail={SOLUTION_DETAILS.smartHome}
        label="Smart home"
        onToggle={(toggled) => onChange({ smartHome: toggled })}
        toggled={toggles.smartHome}
      />
    </DS.Grid>
  );
};
